(function () {
  function getCardImage(el) {
    const card = el.closest('.card-product');
    if (!card) return null;
    return card.querySelector('.card__main-image');
  }

  function getCardLink(el) {
    const card = el.closest('.card-product');
    if (!card) return null;
    return card.querySelector('.expand-link__link');
  }

  function getQuickAddButton(el) {
    const card = el.closest('.card-product');
    if (!card) return null;
    return card.querySelector('quick-add-button');
  }

  function getVariantId(variantUrl) {
    if (!variantUrl) return null;
    const match = variantUrl.match(/[?&]variant=(\d+)/);
    if (match) return match[1];
    // If URL is /products/slug?variant=ID format
    const url = new URL(variantUrl, window.location.origin);
    return url.searchParams.get('variant');
  }

  // Hover: show variant image
  document.addEventListener('mouseover', function (e) {
    const link = e.target.closest('.card-product-variants__swatch-link');
    if (!link || !link.dataset.variantImage) return;
    if (link.closest('.card-product-variants__swatch.disabled')) return;

    const img = getCardImage(link);
    if (!img) return;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }

    img.src = link.dataset.variantImage;
    img.srcset = '';
  });

  // Mouse leave: restore original image (only when leaving the swatch link itself)
  document.addEventListener('mouseout', function (e) {
    const link = e.target.closest('.card-product-variants__swatch-link');
    if (!link) return;
    if (link.contains(e.relatedTarget)) return;

    const img = getCardImage(link);
    if (!img || !img.dataset.originalSrc) return;

    // Only restore if not locked (i.e. user hasn't clicked to select a variant)
    if (img.dataset.variantLocked) return;

    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset || '';
  });

  // Click: lock the variant image and update card link URL
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.card-product-variants__swatch-link');
    if (!link) return;
    if (link.closest('.card-product-variants__swatch.disabled')) return;

    e.preventDefault();
    e.stopPropagation();

    const img = getCardImage(link);
    const cardLink = getCardLink(link);
    const variantImage = link.dataset.variantImage;
    const variantUrl = link.dataset.variantUrl;

    if (img) {
      // Remove lock from siblings first
      const card = link.closest('.card-product');
      const allSwatches = card ? card.querySelectorAll('.card-product-variants__swatch-link') : [];
      allSwatches.forEach(function (s) { s.removeAttribute('aria-pressed'); });

      link.setAttribute('aria-pressed', 'true');

      if (variantImage) {
        img.dataset.originalSrc = variantImage;
        img.dataset.originalSrcset = '';
        img.dataset.variantLocked = '1';
        img.src = variantImage;
        img.srcset = '';

        // Update hover image to variant's second image (or hide if none)
        const hoverImg = card ? card.querySelector('.card__media-hover') : null;
        if (hoverImg) {
          const variantImage2 = link.dataset.variantImage2;
          if (variantImage2) {
            hoverImg.src = variantImage2;
            hoverImg.srcset = '';
            hoverImg.style.display = '';
          } else {
            hoverImg.style.display = 'none';
          }
        }
      }
    }

    if (cardLink && variantUrl) {
      cardLink.href = variantUrl;
    }

    // Update quick-add-button data-url so the modal opens pre-selecting the variant
    const quickAddBtn = getQuickAddButton(link);
    if (quickAddBtn && variantUrl) {
      quickAddBtn.dataset.url = variantUrl;
    }

    // Update single-variant hidden input (for products with only one variant rendered as a form)
    const card = link.closest('.card-product');
    if (card) {
      const variantId = link.dataset.variantId;
      if (variantId) {
        const hiddenInput = card.querySelector('input[name="id"]');
        if (hiddenInput) hiddenInput.value = variantId;
      }
    }
  });
})();
